import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { AppConfig } from '../../../app/app.config';
import { columns } from './field-positioning-outstanding-grid.config';
import { State } from '@progress/kendo-data-query';
import { KendoGridDataConfig } from '../../../_foundation/kendo/models/grid.models';
import { FieldPositioningService } from '../../../services/field-positioning/field-positioning.service';
import { DailyLogPage } from '../../daily-log/daily-log/daily-log';
import { DateService } from '../../../services/date/date.service';
import { DateParserService } from '../../../services/daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../../../services/time-zone/time-zone.service';

@IonicPage()
@Component({
  selector: 'page-field-positioning-outstanding',
  templateUrl: 'field-positioning-outstanding.html',
})
export class FieldPositioningOutstandingPage {
  @ViewChild('fieldPositioningGrid') grid?: GridComponent;

  config = AppConfig.settings;
  gridData: GridDataResult;
  gridDataConfig: KendoGridDataConfig;
  columns = columns;
  loaded: boolean;

  state: State = {
    take: 500,
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      {
        field: 'operationName',
        dir: 'asc'
      },
    ],
  };

  constructor(
    private navCtrl: NavController,
    private navParams: NavParams,
    private dateService: DateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService,
    private fieldPositioningService: FieldPositioningService) {
  }

  async ionViewDidLoad() {
    await this.loadData();
  }

  private async loadData() {
    this.gridDataConfig = this.fieldPositioningService.getOutstandingFieldPositioningGridDataConfig();
  }

  async openLogAtViewDate(dailyLogDateString: string) {
    const dateTime = await this.dateParserService.deserializeDate(dailyLogDateString, true, this.timeZoneService);
    // let dateTime = await this.dateService.convertLocalJSDateToDateTime(this.viewDate);
    await this.navCtrl.setRoot(DailyLogPage, {inputDate: dateTime});
  }
}



// WEBPACK FOOTER //
// ./src/pages/validation/field-positioning-outstanding/field-positioning-outstanding.ts